// Your React component

import React from 'react';
import './PrintStyle.css';
import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import TitoLogo from '../assets/images/tito-logo.png';
import KKLogo from '../assets/images/kk-logo.png';
import moment from 'moment';

const OrderItemPrint = React.forwardRef((props, ref) => {
    const { product, rep, customer, startDate, endDate, data } = props;

    return (
        <div ref={ref} style={{ padding: 50 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={KKLogo} alt="logo" style={{ height: 100, width: 100 }} />
                <h2>KK Foods</h2>
                <img src={TitoLogo} alt="logo" style={{ height: 100, width: 100 }} />
            </div>

            <Grid container>
                <Grid item lg={2} md={2} sm={2}>
                    <Typography>Rep Name:</Typography>
                </Grid>
                <Grid item lg={10} md={10} sm={10}>
                    <Box sx={{ display: 'flex' }}>
                        {rep?.map((i, index) => (
                            <Typography>
                                {i?.firstName} {i?.lastName}
                                {index < rep?.length - 1 && `,`}
                                <span>&nbsp;</span>
                            </Typography>
                        ))}
                    </Box>
                </Grid>

                <Grid item lg={2} md={2} sm={2}>
                    <Typography>Customer Name:</Typography>
                </Grid>
                <Grid item lg={10} md={10} sm={10}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {customer?.map((i, index) => (
                            <Typography>
                                {i?.name}
                                {index < customer?.length - 1 && ','}
                                <span>&nbsp;</span>
                            </Typography>
                        ))}
                    </Box>
                </Grid>
                <Grid item lg={6} md={6} sm={6}>
                    <Typography>From Date: {startDate}</Typography>
                </Grid>
                <Grid item lg={6} md={6} sm={6}>
                    <Typography>To Date: {endDate}</Typography>
                </Grid>
                <Grid item lg={2} md={2} sm={2}>
                    <Typography>Products:</Typography>
                </Grid>
                <Grid item lg={10} md={10} sm={10}>
                    <Box sx={{ display: 'flex' }}>
                        {product?.map((i, index) => (
                            <Typography>
                                {i?.name}
                                {index < product?.length - 1 && `,`}
                                <span>&nbsp;</span>
                            </Typography>
                        ))}
                    </Box>
                </Grid>
            </Grid>

            <TableContainer>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Product</TableCell>
                            <TableCell>Total Qty Order</TableCell>
                            {/* <TableCell>Total Qty Dispatch</TableCell>
                            <TableCell>Total Qty Remaining</TableCell> */}
                            <TableCell>Available Quantity</TableCell>
                            <TableCell>Raw Material Quantity</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!data &&
                            data?.map((row) => (
                                <TableRow
                                    key={row.name}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 }
                                    }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row?.productName}
                                    </TableCell>
                                    <TableCell>{row?.totalQtyOrder}</TableCell>
                                    {/* <TableCell>{row?.totalQtyDispatch}</TableCell>
                                    <TableCell>{row?.totalQtyRemaining}</TableCell> */}
                                    <TableCell>{row?.availableQuantity}</TableCell>
                                    <TableCell>{row?.rawMaterialQuantity}</TableCell>
                                    <TableCell>{row?.machines}</TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
});

export default OrderItemPrint;
